export default {"src":"/_next/static/media/deco_giftbox.68c76405.svg","height":130,"width":130,"blurWidth":0,"blurHeight":0};